export const COMPETENCIES = [
  { key: "language", label: "Bahasa Jepang", group: "competency" },
  { key: "communication", label: "Komunikasi", group: "competency" },
  { key: "practical_skill", label: "Praktik Keterampilan", group: "competency" },
  { key: "problem_solving", label: "Pemecahan Masalah", group: "competency" },
  { key: "safety", label: "Safety Awareness (K3)", group: "work_readiness" },
  { key: "discipline", label: "Disiplin & Etika Kerja", group: "work_readiness" },
  { key: "teamwork", label: "Kerja Sama Tim", group: "work_readiness" },
  { key: "physical", label: "Fisik & Mental", group: "work_readiness" },
];
